<template>
    <internal>
        <div class="relative p-6 bg-white border-b border-gray-200 overflow-y-scroll h-screen-80 shadow-sm sm:rounded-lg">
            <p class="text-lg font-medium absolute">List Expenses</p>
            <breeze-table :searchable="true" :fields="fields" :items="expenses" :action="{'text':'add expense','url':route('internal.expense.create',branchid)}" :canView="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'View Expense')" :canCreate="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Create Expense')">

                <template #type="data">
                    {{data.item.type.parent?data.item.type.parent.title:data.item.type.title}}
                </template>
                <template #sub_type="data">
                    {{ data.item.type.parent ? data.item.type.title : "N/A"}}
                </template>
                <template #month="{item}">
                    {{ formatDateTypeTwo(item.month)}}
                </template>
                <template #action="data">
                    <button-link :href="route('internal.expense.edit',[branchid,data.item.id])" :class="'mb-1'" v-if="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Edit Expense')">Edit</button-link>
                </template>
            </breeze-table>
        </div>
    </internal>
</template>

<script>
    import Internal from '@/Pages/Internal/Internal'
    import BreezeInput from '@/Components/Input'
    import BreezeLabel from '@/Components/Label'
    import ButtonLink from '@/Components/ButtonLink'
    import CardHeader from '@/Components/CardHeader'
    import BreezeInputError from '@/Components/InputError'
    import BreezeButton from '@/Components/Button'
    import BreezeCheckbox from '@/Components/Checkbox'
    import Loading from '@/Components/Loading'
    import SelectList from '@/Components/SelectList'
    import Exception from '@/Components/Exception'
    import BreezeTable from '@/Components/Table'
    import {formatDateTypeTwo} from "../../../../Utils/Common";

    export default {
        methods: {formatDateTypeTwo},
        components: {
            Internal,
            BreezeInput,
            BreezeLabel,
            ButtonLink,
            CardHeader,
            BreezeInputError,
            BreezeButton,
            BreezeCheckbox,
            Loading,
            Exception,
            BreezeTable,
            SelectList
        },
        props:['expenses'],
        data(){
            return{
                fields:[{'key':'title','label':'Title'},{'key':'amount','label':'Amount Name'},{'key':'month','label':'Date'},
                    {'key':'type','label':'Type'},
                    {'key':'sub_type','label':'Sub Type'},
                    {'key':'action','label':'Action'}],
                branchid:localStorage.branchId,
            }
        },

    }
</script>
